/*
 * Copyright (C) 2023 - present Marek Kuzora - All Rights Reserved.
 */


export default
{
  LaserBattery : 0,
  GaussCannon : 1,
  GaussArtillery : 2,
};
